//Please add the language resource
const soldTo = {
  areaName:'AreaName',
  customerNo:'CustomerNo',
  city:'City',
  areaCode:'AreaCode',
  district:'District',
  soldtoName:'SoldtoName',
  postcode:'Postcode',
  tel:'Tel',
  delStatus:'DelStatus',
  fax:'Fax',
  soldtoNo:'SoldtoNo',
  frozenState:'FrozenState',
  customerGroup:'CustomerGroup',
  msg:{
  }
};
export default soldTo


// WEBPACK FOOTER //
// ./src/page/md/soldTo/lang/soldTo.en.js